declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined;
const isDebug = import.meta.env.VITE_ENV === 'development';

export function initGA(): void {
  if (!measurementId) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  script.onerror = () => console.error('[GA] スクリプトの読み込みに失敗しました');
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, { send_page_view: false });
}

export function trackPageView(path: string, title?: string): void {
  if (isDebug) console.log('[GA] page_view', { page_path: path, page_title: title });
  if (!measurementId || typeof window.gtag === 'undefined') return;

  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title,
    send_to: measurementId,
  });
}
